/**
 * Adds a control to the ol3 map control collection
 * map/commands/map-hover-handler also implements a similar solution specifically for mouse location
 * and it is able to interpret the configuration before creating the map control (which is prefered)
 * TODO: ability to position ol.controls within a ol-control container (e.g. mouse coordinates + zoom in the top-left corner)  
 */
import View = require("./view");
import Utils = require("../utils");
import ol = require("openlayers");
import Portal = require("portal-gis");
const log = Utils.log;

class Control extends View {

    static about = `
Adds a control to the ol3 map control collection

Usage Example:

\`\`\`xml
<CONTROL about="adds a control to the ol3 map control collection" disabled="False" id="zoom-in-tool" mid="app/controls/map-panel">
  <OPTIONS>
    <Values id="position" value="bottom-3 right-2" />
  </OPTIONS>
  <COMMANDS>
    <COMMAND disabled="False" id="zoom-in" mid="app/commands/zoom" text="+" type="action">
      <OPTIONS>
        <Values id="direction" value="in" />
        <Values id="css-name" value="zoom-in" />
        <Values about="Tooltip Description" id="title" value="Zoom In" />
      </OPTIONS>
    </COMMAND>
  </COMMANDS>
</CONTROL>
\`\`\`

    `;

    public static options = {
        "css-name": {
            "about": "the class name to assign to view container",
        },
        "position": {
            "about": "Added to the class name to indicate location",
            "domain": "top[-n]|bottom[-n]|left[-n]|right[-n]|center|middle",
        },
        "region": {
            "about": "Class name to use when creating a container region",
        },
        "stack": {
            "about": "vertical|horizontal (unused)",
        },
        "title": {
            "about": "the title assigned to the view element",
            "default": "controls _text_ value"
        },
    }
    // why not use the underlying view.el?
    public element: HTMLElement;
    public control: ol.control.Control;

    addButton(command: Portal.CommandLeaf, container?: JQuery) {
        let options = Utils.asDictionary(command.Options.Values);
        let btn = document.createElement("button");
        btn.className = options["css-name"];
        btn.innerHTML = command.text;
        btn.onclick = () => this.trigger("command", { command: command });
        btn.title = options["title"] || null;
        this.element.appendChild(btn);
    }

    /**
     * View controls are considered sub-views to be rendered in a region.
     * We need to create the region before registering 
     */
    registerControls(controls = this.configuration.Controls) {
        controls.Controls.forEach(control => {
            let options = Utils.asDictionary(control.Options.Values);
            let regionName = options["region"] || `${control.id}-region`;
            let region = document.createElement("div");
            region.className = regionName;
            this.view.$el.append(region);
            this.view.addRegion(regionName, '.' + regionName);
        });
        log(this.element, this.element.outerHTML);
        return super.registerControls(controls);
    }

    addChild(controller: View) {
        controller.view.className += " ol-sub-control";
        super.addChild(controller);
        log(this.element, this.element.outerHTML);
    }

    broadcast() {
        let options = this.options;
        
        // TODO: should be taking place in View?
        this.configuration.Commands.Commands.forEach(config => {
            this.commands[config.id] = config;
        });
        this.configuration.Events.Events.forEach(config => {
            this.events[config.id] = config;
        });

        let align = options["stack"] || "vertical";
        let position = options["position"];

        let element = this.element = this.view.$el[0]; //document.createElement("div");
        {
            let cssName = ["ol-control map-panel", options["css-name"], position].filter(v => !!v).join(" ");
            element.className = cssName;
        }
        element.title = options["title"] || this.configuration.text;

        let control = this.control = new ol.control.Control({
            element: element
        });

        this.mediator.mapViewMap(map => {
            map.addControl(control);
        });

        log(this.element, this.element.outerHTML);
        super.broadcast();
        log(this.element, this.element.outerHTML);

    }
}

export = Control;